import { useState } from 'react';
import { useAuditoria } from '../api/hooks';
import { SinPermiso } from '../components/SiPuede';
import { useSesion } from '../context/Sesion';
import type { EventoAuditoria } from '../types/api';
import { fecha } from '../utils/formato';

function quien(e: EventoAuditoria): string {
  if (e.actor.tipo !== 'usuario') return e.actor.tipo;
  return e.actor.nombre ?? e.actor.email ?? e.actor.sub ?? '—';
}

function Detalle({ e }: { e: EventoAuditoria }) {
  if (e.antes == null && e.despues == null && e.detalle == null) return null;
  return (
    <details>
      <summary>antes / después</summary>
      <div className="antes-despues">
        <pre>{JSON.stringify(e.antes, null, 2)}</pre>
        <pre>{JSON.stringify(e.despues ?? e.detalle, null, 2)}</pre>
      </div>
    </details>
  );
}

function Tabla() {
  const [accion, setAccion] = useState('');
  const [recurso, setRecurso] = useState('');
  const eventos = useAuditoria({ accion: accion || undefined, recurso_id: recurso.trim().toUpperCase() || undefined });
  return (
    <>
      <div className="filtros">
        <select value={accion} onChange={(e) => setAccion(e.target.value)} aria-label="Acción">
          <option value="">Todas las acciones</option>
          <option value="config.editar">Cambios de tabla</option>
          <option value="config.crear">Altas de tabla</option>
          <option value="config.desactivar">Desactivaciones</option>
          <option value="config.semilla">Semilla</option>
          <option value="accion.recargar">Recargas pedidas</option>
          <option value="accion.resultado">Resultados de Airflow</option>
          <option value="sesion.entrar">Entradas</option>
          <option value="sesion.salir">Salidas</option>
          <option value="clave.crear">Claves de API creadas</option>
          <option value="clave.revocar">Claves de API revocadas</option>
        </select>
        <input type="search" placeholder="Tabla…" value={recurso} onChange={(e) => setRecurso(e.target.value)} aria-label="Tabla" />
      </div>
      {eventos.isLoading && <p className="cargando">Cargando…</p>}
      {eventos.error && <div className="aviso aviso-error">{eventos.error.message}</div>}
      <table className="tabla">
        <thead>
          <tr>
            <th>Cuándo</th>
            <th>Quién</th>
            <th>Qué</th>
            <th>Sobre</th>
            <th>Motivo</th>
            <th>IP</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {(eventos.data ?? []).map((e) => (
            <tr key={e.id}>
              <td>{fecha(e.occurred_at)}</td>
              <td>{quien(e)}</td>
              <td>
                <code>{e.accion}</code>
              </td>
              <td>{e.recurso_id ?? '—'}</td>
              <td>{e.motivo ?? '—'}</td>
              <td>{e.ip ?? '—'}</td>
              <td>
                <Detalle e={e} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}

export function AuditoriaPage() {
  const { puede } = useSesion();
  return (
    <>
      <h1>Auditoría</h1>
      {puede('dwh.admin') ? <Tabla /> : <SinPermiso rol="dwh.admin" />}
    </>
  );
}
